import { Routes } from '@angular/router';
import { PortalLayoutComponent } from './layout/portal-layout.component';

// Portale aderenti: rotte scritte a mano (nessun ui_config, vedi CLAUDE.md di progetto).
// La Home non esiste ancora: l'ingresso è "Le mie pratiche".
export const routes: Routes = [
  {
    path: '',
    component: PortalLayoutComponent,
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'pratiche' },
      { path: 'pratiche', loadComponent: () => import('./pages/le-mie-pratiche/le-mie-pratiche.page').then(m => m.LeMiePratichePage) },
      { path: 'pratiche/:id', loadComponent: () => import('./pages/pratica/pratica.page').then(m => m.PraticaPage) },
    ],
  },
  { path: '**', redirectTo: 'pratiche' },
];
